import { Box, Icon, Skeleton } from "@outschool/backpack";
import { EnrollmentInput } from "@outschool/gql-backend-generated";
import {
  ActivityEnrollQueryQuery,
  EnrollmentMeetingPurchaseQueryQuery,
  FullCurrentUserFragmentFragment,
} from "@outschool/gql-frontend-generated";
import { fasExclamationTriangle } from "@outschool/icons";
import { useLocalPriceDisplay } from "@outschool/localization";
import React from "react";

import { useOrderContext } from "../OrderContext";
import { LoadedPriceBreakdown } from "./priceBreakdown/LoadedPriceBreakdown";
import RefundPolicy from "./RefundPolicy";

type PriceBreakdownProps = React.PropsWithChildren<{
  // required
  activity: // @ts-ignore TS(2339): Property 'activity' does not exist on type '{ __ty... Remove this comment to see the full error message
  | ActivityEnrollQueryQuery["enrollmentForm"]["activity"]
    // @ts-ignore TS(2339): Property 'activity' does not exist on type '{ __ty... Remove this comment to see the full error message
    | EnrollmentMeetingPurchaseQueryQuery["enrollmentMeetingPurchaseForm"]["activity"];
  // @ts-ignore TS(2339): Property 'section' does not exist on type '{ __ty... Remove this comment to see the full error message
  section?: ActivityEnrollQueryQuery["enrollmentForm"]["section"];
  enrollingOrgAdminUser?: FullCurrentUserFragmentFragment;
  priceCents: number;
  isBuyoutSection: boolean;
  canPayLater?: boolean;
  isMeetingPrepay?: boolean;

  // One of the following must be provided
  enrollmentInputs?: EnrollmentInput[];
  // @ts-ignore TS(2339): Property 'children' does not exist on type '{ __ty... Remove this comment to see the full error message
  learnersAcceptingGiftEnrollments?: ActivityEnrollQueryQuery["currentUser"]["children"];
  donationInput?: { amountCents: number };
  oneOnOneNextBillingDate?: Date;
  useSimplifiedPaymentUI?: boolean;
}>;

export default function PriceBreakdown({
  activity,
  section,
  enrollmentInputs = [],
  learnersAcceptingGiftEnrollments,
  donationInput,
  priceCents,
  isBuyoutSection,
  canPayLater = false,
  isMeetingPrepay,
  oneOnOneNextBillingDate,
  children,
  useSimplifiedPaymentUI,
}: PriceBreakdownProps) {
  const { pricingBreakdown, promoCode, isWeeklyPayment } = useOrderContext();
  // TODO: translate currency disclaimers
  const { isBaseCurrency, currencyDisclaimer } = useLocalPriceDisplay();

  return (
    <Box
      sx={{
        marginTop: "1em",
      }}
    >
      {!pricingBreakdown ? (
        <Skeleton
          variant="rounded"
          width={"100%"}
          height={93}
          sx={{ marginTop: 8, borderRadius: 16 }}
        />
      ) : (
        <LoadedPriceBreakdown
          activity={activity}
          section={section}
          isBuyoutSection={isBuyoutSection}
          pricingBreakdown={pricingBreakdown}
          promoCode={promoCode}
          enrollmentInputs={enrollmentInputs}
          learnersAcceptingGiftEnrollments={learnersAcceptingGiftEnrollments}
          donationInput={donationInput}
          isWeeklyPayment={isWeeklyPayment}
          priceCents={priceCents}
          isMeetingPrepay={isMeetingPrepay}
          canPayLater={canPayLater}
          oneOnOneNextBillingDate={oneOnOneNextBillingDate}
          useSimplifiedPaymentUI={useSimplifiedPaymentUI}
        >
          {children}
        </LoadedPriceBreakdown>
      )}

      {!isBaseCurrency && !!currencyDisclaimer && (
        <Box
          flex
          sx={{
            fontSize: "0.875em",
            marginBottom: "1em",
            color: "grey.700",
            flexDirection: "row",
          }}
        >
          <Box
            flex
            sx={{
              color: "#B28B1E",
              fontSize: "16px",
              marginRight: "0.5em",
              paddingTop: "0.5em",
            }}
          >
            <Icon
              icon={fasExclamationTriangle}
              sx={{
                fontSize: "16px",
              }}
            />
          </Box>
          <Box flex>{currencyDisclaimer}</Box>
        </Box>
      )}
      <RefundPolicy
        priceCents={priceCents}
        isSelfPaced={activity.isSelfPaced}
        isClub={activity.isClub}
      />
    </Box>
  );
}
